import { Modal, Button, FormGroup, FormControl } from "react-bootstrap";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import DeleteConfirmModal from "./DeleteConfirmModal";

const strings = {
    question: "Question",
    cancel: "Cancel",
    delete: "Delete",
    save: "Save",
    confirmDelete: "Are you sure you want to delete this question?",
};

export default class QuestionModal extends PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        initialQuestion: PropTypes.string,
        handleClose: PropTypes.func.isRequired,
        handleSave: PropTypes.func.isRequired,
        handleDelete: PropTypes.func.isRequired,
        question: PropTypes.string,
    };

    state = {
        showDeleteConfirmModal: false,
        question: this.props.initialQuestion,
    };

    _openDeleteConfirmModal = () => this.setState({ showDeleteConfirmModal: true });
    _closeDeleteConfirmModal = () => this.setState({ showDeleteConfirmModal: false });

    _handleChange = e => {
        this.setState({ question: e.target.value });
    };

    _handleSave = () => {
        this.props.handleSave(this.state.question);
    };

    _handleDelete = () => {
        this.setState({ showDeleteConfirmModal: false });
        this.props.handleDelete();
    };

    render() {
        if (this.state.showDeleteConfirmModal) {
            return (
                <DeleteConfirmModal
                    show={this.state.showDeleteConfirmModal}
                    title={strings.confirmDelete}
                    handleClose={this._closeDeleteConfirmModal}
                    handleConfirm={this._handleDelete}
                />
            );
        }
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.question}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup controlId="formControlsTextarea">
                        <FormControl
                            componentClass="textarea"
                            value={this.state.question}
                            onChange={this._handleChange}
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.handleClose}>{strings.cancel}</Button>
                    {this.props.question ? (
                        <Button onClick={this._openDeleteConfirmModal} bsStyle="danger">
                            {strings.delete}
                        </Button>
                    ) : null}
                    <Button onClick={this._handleSave} bsStyle="primary">
                        {strings.save}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
